import axiosInstance from '../../../api/axiosConfig';
import { Placement } from '../types/placement';

export const createPlacement = async (placement: any) => {
    const response = await axiosInstance.post('/placement', placement, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
};

export const updatePlacement = async (id: number, placement: any) => {
    const response = await axiosInstance.patch(`/placement/${id}`, placement, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
}

export const getPlacements = async () => {
    const response = await axiosInstance.get('/placement');
    return response?.data;
};

export const importPlacements = async (formData: any) => {
    const response = await axiosInstance.post('/placement/import', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
};

export const confirmImportPlacements = async (placements: (Placement & { errors: string[] })[]) => {
    const response = await axiosInstance.post<Placement[]>('/placement/confirm-import', placements);
    return response?.data;
};

export const deletePlacement = async (id: number) => {
    const response = await axiosInstance.delete(`/placement/${id}`);
    return response?.data;
};

